import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import all translation files
import en from "../i18n/en.json";
import es from "../i18n/es.json";
import fr from "../i18n/fr.json";
import pt from "../i18n/pt.json";
import it from "../i18n/it.json";

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  pt: { translation: pt },
  it: { translation: it },
};

const isBrowser = typeof window !== "undefined";

if (!i18n.isInitialized) {
  let i18nInstance = i18n;

  const config: any = {
    resources,
    lng: "es",
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    initImmediate: false,
  };

  if (isBrowser) {
    const LanguageDetector =
      require("i18next-browser-languagedetector").default;
    i18nInstance = i18nInstance.use(LanguageDetector);

    config.detection = {
      order: ["navigator", "localStorage", "htmlTag"],
      caches: ["localStorage"],
    };
  }

  i18nInstance = i18nInstance.use(initReactI18next);

  i18nInstance.init(config);
}

// Export the configured i18n instance
export default i18n;
